import { Text } from '$components'
import { ReactNode } from 'react'

export type SettingCardHeadingProps = {
  children?: ReactNode
}

export function SettingCardHeading({ children }: SettingCardHeadingProps) {

  return (
    <Text
      as="h2"
      type="h3"
    >
      { children }
    </Text>
  )
}
